module.exports = __webpack_public_path__ + "img/blur_linear.c90401ad.svg";